<div class="main-content">
  <div class="container-fluid">
    <div class="row equal-height-cards">
      <!-- Left Block: Audio Recording -->
      <div class="col-md-6">
        <div class="card">
          <div class="card-header card-header-primary header-row">
            <div>
              <h4 class="card-title">Recording</h4>
              <!-- <p class="card-category">Select microphone and record audio</p> -->
            </div> 
            <div class="connection-status" *ngIf="streamingMode === 'live'">
              <span class="status-indicator" [class.connected]="serverConnected"
                [class.disconnected]="!serverConnected">
                <i class="material-icons">
                  {{ serverConnected ? 'cloud_done' : 'cloud_off' }}
                </i>
                {{ serverConnected ? 'Connected' : 'Disconnected' }}
              </span>
            </div>
          </div>
          <!-- <div style=" margin-left: 2%;margin-right: 2% !important;margin-top: 1%;"> -->

          <!-- </div> -->
          <div class="card-body">

            <!-- Microphone Selection with Capture Mode Icons -->
            <div class="form-group audio-container">
              <!-- <div class="audio-metadata"> -->
              <div class="recording-expander" *ngIf="showRecordingDetails">
              <jqxExpander #additionalFields [theme]="'material'" [width]="'99%'" [expanded]="isRecordingDetailsExpanded">
                <div class="expander-header">
                  Recording Details
                </div>
                <div class="expander-content">
                  <!-- Single wrapping row: the court fields are only rendered for court
                       organizations, and the remaining fields reflow to fill the gap instead of
                       leaving an empty half-row behind. -->
                  <div class="row recordingdetails first-row">
                    <!-- <div class="col-md-6">
                      <mat-form-field class="example-full-width">
                        <mat-label>Organizations *</mat-label>
                        <input id='organization-values' tabindex="9" name='organization-values' type="text" matInput
                          [formControl]="organizationControl" [matAutocomplete]="organizationValuesAuto"
                          (change)='organizationChange()'>
                        <mat-autocomplete id='organization-values-auto' #organizationValuesAuto="matAutocomplete"
                          (optionSelected)="organizationChangeEvent($event)" [displayWith]="displayFnForOrganization">
                          <mat-option *ngFor="let organization of organizationfilteredOptions | async"
                            [value]="organization">
                            {{organization.customerName}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="organizationControl.hasError('required')">
                          Organization is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div> -->
                     <div class="col-md-6">
                      <mat-form-field class="example-full-width">
                        <mat-label>Department *</mat-label>
                        <input id='department-values' name='department-values' type="text" matInput
                          [formControl]="departmentControl" [matAutocomplete]="departmentValuesAuto"
                          [matTooltip]="displayFn(departmentControl.value) || ''" matTooltipPosition="right"
                          (input)="onDepartmentInput($event.target.value)" (change)='departmentChange()'>
                        <mat-autocomplete id='department-values-auto' #departmentValuesAuto="matAutocomplete"
                          (optionSelected)="departmentChangeEvent($event)" [displayWith]="displayFn">
                          <mat-option *ngFor="let dept of deptfilteredOptions | async" [value]="dept" [matTooltip]="dept.name" matTooltipPosition="right">
                            {{dept.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="departmentControl.hasError('required')">
                          Department is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6" *ngIf="selectedOrgIsCourt">
                      <mat-form-field class="example-full-width">
                        <mat-label>Court Location</mat-label>
                        <input id='courtLocation-values' type="text" matInput [formControl]="courtLocationControl"
                          [matAutocomplete]="courtLocationValuesAuto"
                          [matTooltip]="displayFn(courtLocationControl.value) || ''" matTooltipPosition="right"
                          (input)="onCourtLocationInput($event.target.value)" (change)='courtLocationChange()'>
                        <mat-autocomplete id='courtLocation-values-auto' #courtLocationValuesAuto="matAutocomplete"
                          [displayWith]="displayFn" (optionSelected)="courtLocationChangeEvent($event.option.value)">
                          <mat-option *ngFor="let courtLocation of courtLocationfilteredOptions | async"
                            [value]="courtLocation" [matTooltip]="courtLocation.name" matTooltipPosition="right">
                            {{courtLocation.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="courtLocationControl.hasError('required')">
                          Court Location is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6" *ngIf="selectedOrgIsCourt">
                      <mat-form-field class="example-full-width">
                        <mat-label>Court Room</mat-label>
                        <input id='courtRoom-values' type="text" matInput [formControl]="courtRoomControl"
                          [matAutocomplete]="courtRoomValuesAuto"
                          [matTooltip]="displayFn(courtRoomControl.value) || ''" matTooltipPosition="right"
                          (input)="onCourtRoomInput($event.target.value)" (change)='courtRoomChange()'>
                        <mat-autocomplete id='courtRoom-values-auto' #courtRoomValuesAuto="matAutocomplete"
                          [displayWith]="displayFn" (optionSelected)="courtRoomChangeEvent($event.option.value)">
                          <mat-option *ngFor="let courtRoom of courtRoomfilteredOptions | async" [value]="courtRoom" [matTooltip]="courtRoom.name" matTooltipPosition="right">
                            {{courtRoom.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="courtRoomControl.hasError('required')">
                          Court Room is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6" *ngIf="recordingMode === 'browser'">
                      <mat-form-field class="mic-field-inline">
                        <mat-label>Select Microphone</mat-label>
                        <input id="microphoneSelect" name="microphoneSelect" type="text" matInput
                          [formControl]="microphoneControl" [matAutocomplete]="microphoneAuto"
                          [matTooltip]="microphoneControl.value?.label || (microphoneControl.value?.deviceId ? 'Microphone ' + microphoneControl.value.deviceId.substring(0, 8) : '')"
                          matTooltipPosition="right"
                          (change)='onMicrophoneChange()'>
                        <mat-autocomplete #microphoneAuto="matAutocomplete" (optionSelected)="onMicrophoneChangeEvent()"
                          [displayWith]="displayMicrophoneFn">
                          <mat-option *ngFor="let mic of micFilteredOptions | async" [value]="mic"
                            [matTooltip]="mic.label || 'Microphone ' + mic.deviceId.substring(0, 8)" matTooltipPosition="right">
                            {{ mic.label || 'Microphone ' + mic.deviceId.substring(0, 8) }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>

                      <button mat-icon-button color="primary" class="microphone-refresh-btn"
                        (click)="loadAvailableMicrophones()" [disabled]="isRecording || isPaused"
                        matTooltip="Refresh microphone list" aria-label="Refresh microphone list"
                        style="margin-left: 8px; margin-top: 8px;">
                        <i class="material-icons">refresh</i>
                      </button>
                    </div>
                     <div class="col-md-6">
                      <mat-form-field class="example-full-width">
                        <mat-label>Date &amp; Time</mat-label>
                        <input matInput readonly [value]="currentDateTime | date:'dd MMM yyyy HH:mm:ss'">
                      </mat-form-field>
                    </div>
                    <div class="col-md-6">
                      <span class="external-audio-option"
                        [matTooltip]="cableInputAvailable ? 'Include System Audio' : 'Please Install VB Audio Virtual Cable Drivers'"
                        [matTooltipClass]="cableInputAvailable ? '' : 'warning-tooltip'">
                        <mat-checkbox [(ngModel)]="includeExternalAudio"
                          [disabled]="!cableInputAvailable || isRecording || isPaused || isStartingRecording || isStoppingRecording"
                          color="primary">
                          Include System Audio Output
                        </mat-checkbox>
                      </span>
                    </div>
                    <div class="col-md-6" *ngIf="autoStartTranscription">
                      <mat-form-field class="example-full-width">
                        <mat-label>Language</mat-label>
                        <input id="languageSelect" name="languageSelect" type="text" matInput
                          [formControl]="languageControl" [matAutocomplete]="languageAuto"
                          [matTooltip]="displayLanguageFn(languageControl.value) || ''" matTooltipPosition="right"
                          (change)='onLanguageChange()'>
                        <mat-autocomplete #languageAuto="matAutocomplete" (optionSelected)="onLanguageChangeEvent()"
                          [displayWith]="displayLanguageFn">
                          <mat-option *ngFor="let lang of langFilteredOptions | async" [value]="lang" [matTooltip]="lang.name" matTooltipPosition="right">
                            {{ lang.name }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6" *ngIf="autoStartTranscription">
                      <mat-checkbox [(ngModel)]="translateToEnglish"
                        [disabled]="isRecording || selectedLanguage === 'en-US'" color="primary"
                        class="translate-checkbox">
                        Translate to English
                      </mat-checkbox>
                    </div>
                   
                  </div>
                </div>
              </jqxExpander>
              </div>
        
              <div class="forms-expander" *ngIf="showForms && hasFormsContent" [style.display]="isAnnotationMaximized ? 'none' : null">
              <jqxExpander #formsFields [theme]="'material'" [width]="'99%'" [expanded]="isFormsExpanded">
                <div>
                  Metadata
                </div>
                <div class="expander-content">
                  <div class="row case-details first-row" *ngIf="formsTypeOptions.length > 1">
                  
                    <div class="col-md-6">
                      <mat-form-field class="example-full-width">
                        <mat-label>Form Type</mat-label>
                        <mat-select [(ngModel)]="selectedFormType" [matTooltip]="selectedFormType?.name || ''"
                          matTooltipPosition="right"
                          (selectionChange)="onFormsTypeChange($event.value)">
                          <mat-option *ngFor="let ft of formsTypeOptions" [value]="ft" [matTooltip]="ft.name" matTooltipPosition="right">{{ ft.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  
                    <div class="col-md-12" style="text-align:right;" *ngIf="selectedOrgIsCourt">
                      <button mat-stroked-button color="primary" type="button" (click)="openCaseListDialog()"
                        [disabled]="isRecording || isStartingRecording || isPaused || !selectedOrgExtId"
                        [title]="!selectedOrgExtId ? 'Select an organization first' : ''">
                        <mat-icon>list</mat-icon> Select Case
                      </button>
                    </div>
                  <app-dynamic-form *ngIf="formsFieldsList.length" [fields]="formsFieldsList" [value]="formsFieldValues" (formReady)="onFormsFormReady($event)"></app-dynamic-form>
                </div>
              </jqxExpander>
              </div>
              <div class="case-expander" *ngIf="recordingCaseRows.length > 0" [style.display]="isAnnotationMaximized ? 'none' : null">
                <jqxExpander [theme]="'material'" [width]="'99%'" [expanded]="isCasesExpanded">
                  <div>Cases ({{ recordingCaseRows.length }})</div>
                  <div class="expander-content cases-expander-content">
                    <div #caseTableScrollContainer class="vqc-case-table-wrapper">
                      <table class="vqc-case-table">
                        <thead>
                          <tr>
                            <th>{{ recordingCaseReferenceLabel }}</th>
                            <th>Hearing Date/Time</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Duration</th>
                            <th>Form Data</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let caseRow of recordingCaseRows"
                            [class.selected]="selectedCaseDetailsId === caseRow.id">
                            <td>
                              <span>{{ caseRow.caseNumber }}</span>
                              <span class="recording-now-badge" *ngIf="selectedCaseDetailsId === caseRow.id">
                                Recording now
                              </span>
                              <span class="recording-now-badge completed" *ngIf="selectedCaseDetailsId !== caseRow.id && caseRow.stoppedAt">
                                Completed
                              </span>
                            </td>
                            <td>{{ caseRow.hearingDateTime ? (caseRow.hearingDateTime | date:'EEE MMM dd yyyy HH:mm:ss') : '-' }}</td>
                            <td>{{ caseRow.startedAt | date:'HH:mm:ss' }}</td>
                            <td>{{ caseRow.stoppedAt ? (caseRow.stoppedAt | date:'HH:mm:ss') : '--:--:--' }}</td>
                            <td>{{ getRecordingCaseDuration(caseRow) }}</td>
                            <td class="vqc-case-form-data">
                              <span class="vqc-form-data-summary"
                                [matTooltip]="getRecordingCaseFormSummary(caseRow)">
                                {{ getRecordingCaseFormSummary(caseRow) || '-' }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </jqxExpander>
              </div>
              <div class="annotation-expander" *ngIf="selectedOrgIsCourt && allowAnnotations && showAnnotations && autoStartTranscription">
              <jqxExpander  #annotations  [theme]="'material'" [width]="'99%'" [expanded]="isAnnotationsExpanded">
               <div class="expander-header-container">
                <span>Annotations</span>
              </div>
                  <div class="row case-details first-row">
                   <app-annotation #annotationComp [recordingDuration]="recordingDuration" [pausedAt]="annotationPauseTime" [recordingId]="recordingId" [caseDetailsId]="selectedCaseDetailsId" [speakers]="annotationSpeakers" [filterByCaseDetailsId]="false" [autoStartTranscription]="autoStartTranscription" [class.fullscreen]="isAnnotationMaximized" (toggleMaximize)="setAnnotationDetailVisibility($event)" (updateAudioPosition)="onAnnotationPositionSelected($event)"></app-annotation>
                  </div>
               
              </jqxExpander>
              </div>
              <!-- </div> -->
              
              
              <!-- Send to Server -->
              <div class="send-section" *ngIf="recordedAudioBlob && streamingMode === 'batch'">
                <div class="recorded-info">
                  <i class="material-icons">check_circle</i>
                  <span>Recording completed ({{ recordedAudioSize }})</span>
                </div>
                <button mat-raised-button color="primary" (click)="sendAudioToServer()" [disabled]="isSending"
                  class="send-btn">
                  <i class="material-icons">send</i>
                  {{ isSending ? 'Sending...' : 'Send to Server' }}
                </button>
              </div>
            </div>
          </div>
          <div class="recording-controls">
                  <!-- Initial State: Start New Recording Button -->
                  <button *ngIf="!isRecording && !isPaused && !isStoppingRecording" 
                    (click)="startRecording()"
                    [disabled]="isStartingRecording || (recordingMode === 'browser' && captureMode === 'microphone' && !selectedMicrophone) || (recordingMode === 'wasapi' && !selectedWasapiDevice)"
                    class="custom-btn control-btn start-new-btn">
                    <mat-spinner *ngIf="isStartingRecording" diameter="18" class="start-recording-spinner"></mat-spinner>
                    <i class="material-icons btn-icon" *ngIf="!isStartingRecording">
                      {{ captureMode === 'system' ? 'speaker_phone' : 'mic' }}
                    </i>
                    <span>{{ isStartingRecording ? 'Starting Recording...' : 'Start New Recording' }}</span>
                  </button>

                  <div *ngIf="isRecording || isPaused || isStoppingRecording" class="recording-active-controls">
                    <!-- 1. Pause / Resume circular icon -->
                    <button mat-icon-button (click)="isPaused ? resumeRecording() : pauseRecording()"
                      [disabled]="isStoppingRecording" class="rec-circle-btn rec-action-btn" [class.is-paused]="isPaused"
                      [matTooltip]="isPaused ? 'Resume Recording' : 'Pause Recording'">
                      <i class="material-icons">{{ isPaused ? 'fiber_manual_record' : 'pause' }}</i>
                    </button>
                    <!-- 2. Recording Timer -->
                    <span class="rec-timer">{{ recordingDuration }}</span>
                    <!-- 3. Mic Recording Level -->
                    <div class="rec-audio-level">
                      <button *ngIf="channelMixer?.strips?.length; else plainLevelIcon" type="button"
                        class="rec-channels-btn" [matMenuTriggerFor]="channelsMenu"
                        matTooltip="Channel levels" aria-label="Show channel levels">
                        <i class="material-icons rec-mic-icon">graphic_eq</i>
                      </button>
                      <ng-template #plainLevelIcon>
                        <i class="material-icons rec-mic-icon" aria-hidden="true">graphic_eq</i>
                      </ng-template>
                      <mat-menu #channelsMenu="matMenu" class="channel-mixer-menu" yPosition="above">
                        <ng-template matMenuContent>
                          <app-channel-strips [mixer]="channelMixer" [active]="isRecording && !isPaused"></app-channel-strips>
                        </ng-template>
                      </mat-menu>
                      <div class="rec-level-col">
                        <span class="rec-level-label" [matTooltip]="'Audio Level ' + micLevel + '%'"><span class="rec-level-caption">Audio Level </span>{{ micLevel }}%</span>
                        <div class="rec-level-bar">
                          <div class="rec-level-fill" [style.width.%]="micLevel"></div>
                        </div>
                      </div>
                    </div>
                    <div class="rec-paused-badge" *ngIf="isPaused" [matTooltip]="'Paused for: ' + pausedForDuration">
                    <i class="material-icons">pause</i>
                    <span><span class="rec-paused-caption">Paused for: </span><strong class="rec-paused-timer">{{ pausedForDuration }}</strong></span>
                  </div>
                    <!-- 4. Mute toggle circular -->
                    <button (click)="toggleRecordingMute()" class="rec-mute-btn rec-action-btn" [class.muted]="isMuted"
                      [matTooltip]="isMuted ? 'Unmute' : 'Mute'">
                      <i class="material-icons">{{ isMuted ? 'mic_off' : 'mic' }}</i>
                    </button>
                    <!-- 5. Stop & Finalize -->
                    <button class="rec-new-case-btn rec-action-btn" (click)="openNewCaseDialog()"
                      [disabled]="isStoppingRecording || !recordingId || !currentRoomName"
                      matTooltip="Create a new case">
                      <!-- <mat-spinner *ngIf="isCreatingNewCase" diameter="18"></mat-spinner> -->
                      <i class="material-icons">note_add</i>
                      
                    </button>
                    <button class="rec-stop-btn" (click)="confirmStopRecording()" [disabled]="isStoppingRecording"
                      matTooltip="Stop &amp; Finalize" aria-label="Stop and finalize recording">
                      <mat-spinner *ngIf="isStoppingRecording" diameter="18"
                        style="display:inline-block;"></mat-spinner>
                      <i class="material-icons rec-stop-icon" *ngIf="!isStoppingRecording">stop</i>
                      <span class="rec-stop-label" *ngIf="!isStoppingRecording">Stop &amp; Finalize</span>
                      <span class="rec-stop-label" *ngIf="isStoppingRecording">Stopping...</span>
                    </button>
                  </div>
                  <!-- Paused indicator badge -->
                  <!-- <div class="rec-paused-badge" *ngIf="isPaused">
                    <i class="material-icons">pause</i>
                    <span>Paused for: <strong class="rec-paused-timer">{{ pausedForDuration }}</strong></span>
                  </div> -->
          </div>
        </div>
      </div>


      <!-- Right Block: Transcription -->
      <div class="col-md-6">
        <div class="card">
          <div *ngIf="autoStartTranscription"  class="card-header card-header-primary header-row">
            <div>
              <h4 class="card-title">Transcription</h4>
              <!-- <p class="card-category">Real-time transcription results</p> -->
            </div>
            <div class="transcription-header">
              
              <button mat-icon-button (click)="goToList()" [disabled]="isRecording || isPaused ||isStoppingRecording"
                      class="transcription-action-icon" matTooltip="View recordings list" aria-label="List recordings">
                <i class="material-icons">view_list</i>
              </button>
              <button mat-icon-button (click)="copyTranscription()" [disabled]="!transcriptionText"
                class="transcription-action-icon" matTooltip="Copy transcription" aria-label="Copy transcription">
                <i class="material-icons">content_copy</i>
              </button>
              <button mat-icon-button (click)="downloadTranscription()" [disabled]="!transcriptionText"
                class="transcription-action-icon" matTooltip="Download transcription"
                aria-label="Download transcription">
                <i class="material-icons">download</i>
              </button>
              <button mat-icon-button (click)="toggleTimestamps()" [disabled]="!transcriptionText"
                class="transcription-action-icon" matTooltip="Toggle timestamps" aria-label="Toggle timestamps">
                <i class="material-icons">access_time</i>
              </button>
            </div>
          </div>
           <div *ngIf="selectedOrgIsCourt && !autoStartTranscription && allowAnnotations" class="card-header card-header-primary header-row">
            <div>
              <h4 class="card-title">Annotations</h4>
            </div>
             <div class="transcription-header">
              <button mat-icon-button (click)="goToList()" [disabled]="isRecording || isPaused ||isStoppingRecording"
                      class="transcription-action-icon" matTooltip="View recordings list" aria-label="List recordings">
                <i class="material-icons">view_list</i>
              </button>
            </div>
          </div>
           <div *ngIf="!autoStartTranscription && !allowAnnotations"  class="card-header card-header-primary header-row">
          <div>
              <h4 class="card-title"></h4>
            </div>
            <div class="transcription-header">
              
              <button mat-icon-button (click)="goToList()" [disabled]="isRecording || isPaused ||isStoppingRecording"
                      class="transcription-action-icon" matTooltip="View recordings list" aria-label="List recordings">
                <i class="material-icons">view_list</i>
              </button>
            </div>
          </div>
          <div *ngIf="autoStartTranscription" class="card-body" >
            <div class="transcription-info">
              <span><strong>Words:</strong> {{ wordCount }}</span>
              <span><strong>Characters:</strong> {{ characterCount }}</span>
              <span><strong>Last Updated:</strong> {{ lastUpdated | date:'short' }}</span>
            </div>


            <!-- Transcription Text Box -->
            <div class="transcription-container">
              <!-- Transcription Status -->
              <!-- <div class="transcription-status" *ngIf="isTranscribing">
              <mat-spinner diameter="20"></mat-spinner>
              <span>Transcribing audio...</span>
            </div> -->
              <div #scrollContainer class="transcription-display" (scroll)="onTranscriptionScroll()">
                <ng-container *ngFor="let segment of finalTranscriptionSegments; trackBy: trackByTranscriptionSegment">
                  <div class="transcription-case-marker" *ngIf="segment.isCaseMarker">
                    <span>New Case Started: {{ segment.caseLabel }} ({{ formatTimestamp(segment.startTime) }})</span>
                  </div>
                  <div class="transcription-segment" *ngIf="!segment.isCaseMarker" [attr.data-start-time]="segment.startTime">
                    <div class="transcription-speaker">
                      <ng-container *ngIf="showTimestamps">[{{ formatTimestamp(segment.startTime) }} - {{
                        formatTimestamp(segment.endTime) }}] </ng-container>
                      <span>🎙️ {{ segment.speaker }}:</span>
                    </div>
                    <div class="transcription-text" *ngIf="hasSegmentTranslation(segment); else sourceOnlyFinal">
                      <div><em style="color: #1976d2; font-style: italic;">(source):</em> {{ segment.text }}</div>
                      <div style="margin-top: 8px;"><em style="color: #388e3c; font-style: italic; font-weight: 700;">(translated):</em>
                        <strong>{{ segment.translatedText }}</strong>
                      </div>
                    </div>
                    <ng-template #sourceOnlyFinal>
                      <div class="transcription-text">{{ segment.text }}</div>
                    </ng-template>
                  </div>
                </ng-container>

                <div class="legacy-transcription-text"
                  *ngIf="!finalTranscriptionSegments.length && transcriptionText && !interimTranscriptionSegment">
                  {{ transcriptionText }}
                </div>

                <div class="transcription-empty"
                  *ngIf="!finalTranscriptionSegments.length && !transcriptionText && !interimTranscriptionSegment">
                  Transcription will appear here...
                </div>
              </div>

              <button type="button" class="go-to-current-btn" *ngIf="isTranscriptionScrolledUp"
                (click)="goToCurrentTranscription()">
                Go to Current
                <svg class="go-to-current-arrow" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 4v15M5 12l7 7 7-7" />
                </svg>
              </button>

              <!-- Interim Transcription (lighter/italic) -->
              <div class="interim-transcription">
                <ng-container *ngIf="interimTranscriptionSegment as interim">
                <div class="transcription-segment" *ngIf="interim.text?.trim() || interim.translatedText?.trim()">
                  <div class="transcription-speaker">
                    <ng-container *ngIf="showTimestamps">[{{ formatTimestamp(interim.startTime) }} - {{
                      formatTimestamp(interim.endTime) }}] </ng-container>
                    <span>🎙️ {{ interim.speaker }} (interim):</span>
                  </div>
                  <div class="transcription-text" *ngIf="hasSegmentTranslation(interim); else sourceOnlyInterim">
                    <div><em style="color: #1565c0; font-style: italic;">(source):</em> {{ interim.text }}</div>
                    <div><em style="color: #256b29; font-style: italic; font-weight: 700;">(translated):</em>
                      <strong>{{ interim.translatedText }}</strong>
                    </div>
                  </div>
                  <ng-template #sourceOnlyInterim>
                    <div class="transcription-text"><strong>{{ interim.text }}</strong></div>
                  </ng-template>
                </div>
                </ng-container>
              </div>


            </div>

            <!-- Transcription History -->
            <div class="transcription-history" *ngIf="transcriptionHistory.length > 0">
              <h5>Previous Transcriptions</h5>
              <div class="history-list">
                <div class="history-item" *ngFor="let item of transcriptionHistory; let i = index"
                  (click)="loadTranscription(i)">
                  <div class="history-item-header">
                    <span class="history-date">{{ item.timestamp | date:'short' }}</span>
                    <button mat-icon-button (click)="deleteHistoryItem(i); $event.stopPropagation()" class="delete-btn">
                      <i class="material-icons">delete</i>
                    </button>
                  </div>
                  <div class="history-preview">
                    {{ item.text.substring(0, 100) }}{{ item.text.length > 100 ? '...' : '' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="selectedOrgIsCourt && !autoStartTranscription && allowAnnotations" class="card-body" >
            <div class="annotation-expander" >
              <jqxExpander  #annotations  [theme]="'material'" [width]="'99%'" [expanded]="isAnnotationsExpanded">
               <div class="expander-header-container">
                <span>Annotations</span>
              </div>
                  <div class="row case-details first-row">
                   <app-annotation  *ngIf="showAnnotations && !autoStartTranscription"   #annotationComp [style.height]="!autoStartTranscription ? 'var(--tall-size)' : 'var(--short-size)'" [recordingDuration]="recordingDuration" [pausedAt]="annotationPauseTime" [recordingId]="recordingId" [caseDetailsId]="selectedCaseDetailsId" [speakers]="annotationSpeakers" [filterByCaseDetailsId]="false" [autoStartTranscription]="autoStartTranscription" [class.fullscreen]="isAnnotationMaximized" (toggleMaximize)="setAnnotationDetailVisibility($event)" (updateAudioPosition)="onAnnotationPositionSelected($event)"></app-annotation>
                  </div>
              </jqxExpander>
              </div>
          </div>
          <div *ngIf="!autoStartTranscription && !allowAnnotations" class="card-body" >
            
          </div>
         <div class="player-container" [class.player-disabled]="!isRecording && !isPaused && !isStoppingRecording">
                    <audio #audioRef style="display:none;" controlsList="nodownload"
                        (loadedmetadata)="onAudioLoadedMetadata()"
                        (timeupdate)="onAudioTimeUpdate()"
                        (ended)="onAudioEnded()">
                    </audio>

                    <div class="player-time-labels">
                        <span>{{ recordingStartDateTime | date:'EEE MMMM dd yyyy
                        HH:mm:ss' }}</span>
                        <span></span>
                    </div>

                    <div class="timeline-slider-wrapper">
                        <input type="range" id="timelineSlider" class="timeline-slider" aria-label="Recording playback position" min="0"
                            [max]="audioDuration || 0" [value]="audioCurrentTime || 0" (input)="seekTo($event.target.value)" />
                    </div>

                    <div class="duration-counters">
                        <span>{{ formatTime(audioCurrentTime) }}</span>
                        <div class="control-group-center">
                            <div class="media-controls-container">
                              <button type="button" class="rec-mute-btn rec-action-btn" matTooltip="Rewind 10 seconds"
                                aria-label="Rewind 10 seconds" (click)="skipAudio(-10)">
                                <i class="material-icons" aria-hidden="true">replay_10</i>
                              </button>

                              <button type="button" class="rec-circle-btn rec-action-btn"
                                [matTooltip]="isAudioPlaying ? 'Pause playback' : 'Play recording'"
                                [attr.aria-label]="isAudioPlaying ? 'Pause playback' : 'Play recording'"
                                (click)="toggleAudioPlayPause()">
                                <i class="material-icons" aria-hidden="true">{{ isAudioPlaying ? 'pause' : 'play_arrow' }}</i>
                              </button>

                              <button type="button" class="rec-mute-btn rec-action-btn" matTooltip="Forward 10 seconds"
                                aria-label="Forward 10 seconds" (click)="skipAudio(10)">
                                <i class="material-icons" aria-hidden="true">forward_10</i>
                              </button>
                                
                            </div>
                            <div class="volume-container" title="Volume control">
                                <button type="button" class="rec-mute-btn rec-action-btn" id="muteBtn"
                                  [class.muted]="audioVolume === 0" [attr.aria-pressed]="audioVolume === 0"
                                  [matTooltip]="audioVolume > 0 ? 'Mute playback' : 'Unmute playback'"
                                  [attr.aria-label]="audioVolume > 0 ? 'Mute playback' : 'Unmute playback'"
                                  (click)="toggleMute()">
                                  <i class="material-icons" aria-hidden="true">{{ audioVolume > 0 ? 'volume_up' : 'volume_off' }}</i>
                                </button>
                                    <input id="volumeSlider" class="volume-slider" type="range" aria-label="Playback volume" min="0" max="1" step="0.01" [value]="audioVolume" (input)="onVolumeChange($event)" />
                                </div>
                            <button type="button" class="rec-mute-btn rec-action-btn" [matMenuTriggerFor]="playbackChannelsMenu"
                              (menuOpened)="attachPlaybackChannels()"
                              matTooltip="Playback channels" aria-label="Show playback channels">
                              <i class="material-icons" aria-hidden="true">graphic_eq</i>
                            </button>
                            <mat-menu #playbackChannelsMenu="matMenu" class="channel-mixer-menu" yPosition="above">
                              <ng-template matMenuContent>
                                <app-channel-strips [mixer]="playbackChannels.mixer" [active]="isAudioPlaying"></app-channel-strips>
                              </ng-template>
                            </mat-menu>
                        </div>
                        <span>{{ formatTime(audioDuration) }}</span>
                    </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<jqxNotification #msgNotification [position]="'top-right'" [opacity]="1.0" [autoOpen]="false" [autoClose]="true"
  [animationOpenDelay]="800" [autoCloseDelay]="5000" template.success>
</jqxNotification>